import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Select, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import { CloseCircleOutlined } from '@ant-design/icons';
import queryString from 'query-string';
import { sysPageList } from './sys-page-link';
import ChooseGoods from './choose-goods';
import ChooseCoupon from './choose-coupon';
import ChooseGoodsCard from './choose-goods-card';
import ChooseCate from './choose-cate';
import ChoosePage from './choose-page';
import ChooseShop from './choose-shop';
import can from '../../../../components/ability';

const customPath = '/pages/operation/index'

export default (props) => {
    
    const { value, onChange, addons } = props;
    const [list, setList] = useState([]);
    const globalConfig = useContext(FormConfigContext);
    const { accId, shopId } = globalConfig;

    const [pageV, setPageV] = useState({
        v: undefined,
        params: {},
        obj: {}
    });

    const form = useForm();

    const getPageList = async () => {
        
        const response = await fetch(`/api/page/list?shopId=${shopId}`);
        const result = await response.json();
        const rows = result?.data?.rows || [];

        if (result?.success) {
            const list = [];
            sysPageList.forEach(i => {
                list.push({
                    ...i,
                    label: i.name,
                    value: i.path
                })
            })
            return list.concat(rows.filter(i => {
                i.label = i.title;
                i.value = i.pageId;
                return i.code === 'custom'
            }));
        } else {
            message.error(result.data);
            return []
        }
    }
    function onChangePage(v, obj) {
        let path = v
        if (obj?.code === 'custom') {
            path = `${customPath}?pageId=${v}`;
        } 
        onChange(path)
    }  
    function changePage(allValues, changedValues) {
        let path = pageV.v;
        const params = allValues || {};
        if (pageV?.obj?.code === 'custom') {
            path = customPath;
            params.pageId = pageV?.obj?.pageId
        }
        const url = `${path}?${queryString.stringify(params, {skipNull: true })}`;
        onChange(url)
    }
    useEffect(() => {
        const str = value || '';
        const [path, params] = str.split('?')
        const paramsObj = queryString.parse(params || '') || {};
        let newPv = {};
        if (path === customPath) {
            newPv = {
                v: paramsObj.pageId,
                params: {},
                obj: list.find(i => i.value === paramsObj.pageId)
            }
        } else {
            newPv = {
                v: path,
                params: paramsObj,
                obj: list.find(i => i.value === path)
            }
        }
        form.setValues(newPv.params)
        setPageV(newPv);
    }, [value, list]);
    useEffect(() => {
        getPageList().then(res => setList(res));
        return;
    }, []);
    
    return (
        <div className='comp-form-customer-field'>
            <Select
                style={{width: '100%'}}
                onChange={onChangePage}
                value={pageV.v || undefined}
                options={list}
                placeholder="请选择页面"
                allowClear
            />
            <div className='page-params'>
                {
                    pageV?.obj?.schema ? (
                        <FormRender 
                            widgets={{ ChooseGoods, ChooseCoupon, ChooseGoodsCard, ChooseCate, ChoosePage, ChooseShop }}
                            form={form}
                            schema={pageV?.obj?.schema} 
                            watch={{'#': changePage}}
                            maxWidth={360} 
                        />
                    ) : null
                }
            </div>
        </div>
    );
};